module.exports = __webpack_public_path__ + "img/7852d7cdc66caca0c97d1a9313d4c4df.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo12.png
// module id = 920
// module chunks = 5